import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './store';

/**
 * Захищає tenant-scoped routes (AppLayout та все всередині).
 *
 * Якщо user залогінений (RequireAuth відпустив), але `activeTenantId` не
 * виставлений — кидаємо на /select-tenant, який сам вирішить:
 *  - 0 tenants → /no-tenants
 *  - 1 tenant  → автовибір → /
 *  - N tenants → UI вибору
 */
export default function RequireTenant({ children }: { children: ReactNode }) {
  const tenantId = useAuth((s) => s.activeTenantId);
  if (!tenantId) {
    return <Navigate to="/select-tenant" replace />;
  }
  return <>{children}</>;
}
